export default __webpack_public_path__ + "static/media/14.61bcb046.png";